import React from "react";

const PublicPageShell = ({ children, className = "" }) => (
  <div className={`mx-auto w-full max-w-screen-xl px-4 lg:px-8 pb-4 ${className}`.trim()}>
    {children}
  </div>
);

export default PublicPageShell;
